import React from 'react';
import { Redirect } from 'react-router-dom';
import usePromiseWaiting from '../../hooks/usePromiseWaiting';
import { hasActiveMatches } from '../../models/job-matches';
import routes from '../../routes';
import { useEngineer } from '../EngineerProvider';
import ErrorDisplay from '../ErrorDisplay';
import LoadingPage from '../Loading/Page';
import Page from '../Page';

export default function Jobs() {
  const { engineer, fetching: fetchingEngineer } = useEngineer();
  const [loading, hasActiveJobs, error] = usePromiseWaiting(
    () => (engineer?.id ? hasActiveMatches(engineer.id) : null),
    [engineer?.id],
  );
  let content = null;
  if (fetchingEngineer || loading) {
    content = <LoadingPage />;
  } else if (error) {
    content = <ErrorDisplay error="There was an error fetching jobs for you" showReload />;
  } else {
    content = <Redirect to={hasActiveJobs ? routes.jobs.active : routes.jobs.potential} />;
  }
  return (
    <Page title="Jobs">{content}</Page>
  );
}
